import { Action } from '@reduxjs/toolkit';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';

import { RootState } from 'app/redux/rootReducer';

import { fetchDashboardDataSuccess } from 'features/entities/entitiesSlice';
import { menuGroupsCreated } from './menuSlice';
import { createAccountMenuGroups, createServicesMenuGroups } from './menuGroups';
import { Observable } from 'rxjs';

export const menuFetchDashboardDataSuccessEpic = (
  action$: Observable<Action>,
  state$: Observable<RootState>
) =>
  action$.pipe(
    filter(fetchDashboardDataSuccess.match),
    withLatestFrom(state$),
    mergeMap(([, state]) => {
      const settingsGroups = createAccountMenuGroups(state);
      const servicesGroups = createServicesMenuGroups(state);

      return [menuGroupsCreated({ settingsGroups, servicesGroups })];
    })
  );
